(function () {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhItemChooser', ihhItemChooser);

    ihhItemChooser.$inject = ['$timeout'];

    /**
     * A directive that shows an item chooser supporting sorting, filtering by properties, and full text filtering.
     * The directive is configured via the config $scope object, which must be obtained from
     * {@link ihh-common-web.ihh-item-chooser.ItemChooserSvc}
     * @ngdoc directive
     * @memberOf ihh-common-web.ihh-item-chooser
     * @name ihh-item-chooser
     * @attr {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config} config The configuration object.
     */
    function ihhItemChooser($timeout) {
        return {
            restrict: 'AE',
            transclude: true,
            link: function(scope, element) {
                // this is to allow empty formatting of the directive
                var transcluded = element.find('#transcluded').contents();
                var hasEligibleContent = false;
                for (var i = 0; i < transcluded.length; i++) {
                    if (transcluded[i].nodeName === '#text' || transcluded[i].nodeName === 'SPAN') {
                        if (transcluded[i].textContent.trim().length > 0) {
                            hasEligibleContent = true;
                            break;
                        }
                    }
                    else if (transcluded[i].nodeName !== '#comment') {
                        hasEligibleContent = true;
                        break;
                    }
                }
                scope.hasTransclusion = hasEligibleContent;

                scope.closeDropdown = function($event) {
                    $timeout(function() {
                        $event.target.parentElement.parentElement.parentElement.click();
                    });
                };
            },
            scope: {
                config: '='
            },
            controller: 'ItemChooserCtrl',
            templateUrl: 'item-chooser/item-chooser.tpl.html'
        };
    }
})();